import { Grid, Link, Stack, Typography } from '@mui/material';
import { FloatScanButton } from 'components';
import { useTranslation } from 'react-i18next';
import { useSystemActions } from 'stores';
import { MotionWrapper } from 'utils';

interface GetHelpProps {
	timeout?: boolean;
}

const GetHelp = ({ timeout = false }: GetHelpProps) => {
	const { t } = useTranslation();
	const { getImage } = useSystemActions();

	return (
		<MotionWrapper>
			<Stack
				direction="column"
				spacing={1}
				alignItems="center"
				justifyContent="flex-start"
				p={2}
				pb={6}
				sx={{ overflow: 'scroll' }}
			>
				<Typography
					p={2}
					color="primary.main"
					align="justify"
					style={{ whiteSpace: 'pre-line', fontWeight: 'bold' }}
					variant="h5"
				>
					{timeout ? t('app.user.timeout') : t('app.user.help')}
				</Typography>
				<Typography
					p={2}
					color="primary.main"
					align="justify"
					style={{ whiteSpace: 'pre-line' }}
				>
					{t('app.user.text3_orientica')}
				</Typography>
				<Grid
					container
					direction="row"
					justifyContent="space-around"
					alignItems="center"
					pl={1}
					pr={1}
				>
					<Grid item xs={3.15}>
						<Link
							href="https://apps.apple.com/us/app/accessreal-2-0/id1381300990?l=zh&ls=1"
							sx={{
								display: 'block',
								aspectRatio: 'calc(504/168)',
								backgroundImage: `url(${getImage(
									'app_store_btn.png'
								)})`,
								backgroundSize: '100% 100%',
								backgroundPosition: 'center',
							}}
						/>
					</Grid>
					<Grid item xs={3.5}>
						<Link
							href="https://ar2.accessreal.com/apiSys/version/versionUpdating?companyCode=axbsec&appCode=Android_customer"
							sx={{
								display: 'block',
								aspectRatio: 'calc(564/168)',
								backgroundImage: `url(${getImage(
									'apk_file_btn.png'
								)})`,
								backgroundSize: '100% 100%',
								backgroundPosition: 'center',
							}}
						/>
					</Grid>
					<Grid item xs={3.5}>
						<Link
							href="https://ar2.accessreal.com/apiSys/version/versionUpdating?companyCode=axbsec&appCode=Android_customer"
							sx={{
								display: 'block',
								aspectRatio: 'calc(567/169)',
								backgroundImage: `url(${getImage(
									'google_play_btn.png'
								)})`,
								backgroundSize: '100% 100%',
								backgroundPosition: 'center',
							}}
						/>
					</Grid>
				</Grid>
				<Typography
					p={2}
					color="primary.main"
					align="justify"
					style={{ whiteSpace: 'pre-line' }}
				>
					{t('app.user.text4_orientica')}
				</Typography>
			</Stack>
			<FloatScanButton />
		</MotionWrapper>
	);
};

export default GetHelp;
